import React from 'react'
import Icon from '@ant-design/icons'
import { AntdIconProps } from '@ant-design/icons/es/components/AntdIcon'

const TrainingSvg = () => {
  return (
    <svg
      id='prefix__Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      x={0}
      y={0}
      viewBox='0 0 67 49'
      xmlSpace='preserve'
      width='50px'
      height='50px'
    >
      <style>{'.prefix__st0{fill:#bac5d4}'}</style>
      <path className='prefix__st0' d="M4.9,10.3h8.2c.3,0,.6-.3.6-.6s-.3-.6-.6-.6H4.9c-.3,0-.6.3-.6.6s.3.6.6.6Z"/>
      <path className='prefix__st0' d="M4.9,6h8c.3,0,.6-.3.6-.6s-.3-.6-.6-.6H4.9c-.3,0-.6.3-.6.6s.3.6.6.6Z"/>
      <path className='prefix__st0' d="M7.4,13.3h-2.4c-.3,0-.6.3-.6.6s.3.6.6.6h2.4c.3,0,.6-.3.6-.6s-.3-.6-.6-.6Z"/>
      <path className='prefix__st0' d="M7.4,17.6h-2.4c-.3,0-.6.3-.6.6s.3.6.6.6h2.4c.3,0,.6-.3.6-.6s-.3-.6-.6-.6Z"/>
      <path className='prefix__st0' d="M24.3,12.3h-6.2V3.7C18.1,1.6,16.4,0,14.4,0H3.7C1.6,0,0,1.6,0,3.7v15.2C0,20.8,1.6,22.5,3.7,22.5h5.9v1.6c0,1.1.9,2,2,2h12.7c1.1,0,2-.9,2-2v-9.7c0-1.1-.9-2-2-2ZM3.7,21.2c-1.3,0-2.4-1.1-2.4-2.4V3.7c0-1.3,1.1-2.4,2.4-2.4h10.8c1.3,0,2.4,1.1,2.4,2.4v8.7h-5.3c-1.1,0-2,.9-2,2v6.9H3.7ZM25,24c0,.4-.3.7-.7.7h-12.7c-.4,0-.7-.3-.7-.7v-9.7c0-.4.3-.7.7-.7h12.7c.4,0,.7.3.7.7v9.7Z"/>
      <path className='prefix__st0' d="M17.4,15.6c-.2-.2-.5-.2-.7-.1-.2,0-.4.3-.4.6v6.3c0,.3.2.5.4.6,0,0,.2,0,.2,0,.2,0,.3,0,.4-.2l3.1-3.1c.2-.2.2-.6,0-.9l-3.1-3.1ZM17.6,20.8v-3.2l1.6,1.6-1.6,1.6Z"/>
    </svg>
  )
}

export const TrainingIcon = (props: AntdIconProps) => (
  <Icon component={TrainingSvg} {...(props as any)} />
)
